// extracted by mini-css-extract-plugin
module.exports = {"table":"SummaryFields_table__1D_Uz"};